// Module
var code = "<h2 id=\"dont-want-paper\">Don&#39;t want paper?</h2> <p>Enroll in Paperless Billing today!</p> ";
// Exports
export default code;